import normalizeNumber from "./normalizeNumber";

export default function calcBmi(heightCm, weightKg) {
  const h = normalizeNumber(heightCm);
  const w = normalizeNumber(weightKg);
  if (!h || !w || h <= 0 || w <= 0) return { bmi: null, status: "Invalid" };

  const bmi = +(w / Math.pow(h / 100, 2)).toFixed(1);

  let status = "Obese";
  if (bmi < 18.5) status = "Underweight";
  else if (bmi < 25) status = "Normal";
  else if (bmi < 30) status = "Overweight";

  return { bmi, status };
}